<template>
    <div class="inquiry-wrap mobile-toast-popup" :class="[{active : visibleYescoinsFilterMobileToastPopup}]">
        <div class="opacity-bg pc-none" @click.prevent="closeResultFilter"></div>
        <div class="order-history-inquiry toast-layout">
            <div class="toast-name pc-none">내역조회 설정</div>
            <div class="inquiry-filter position-relative">
                <button @click.self="reset" class="btn__reset btn-xs position-absolute tablet-none">초기화</button>

                <div class="inquiry-filter__primary">
                    <div class="filter__item filter__item-date">
                        <p class="filter__title">사용일시</p>
                        <div class="filter__body filter__body filter__body-date">
                            <ul class="body__btns body__btns-date">
                                <li><input class="visually-hidden" type="radio" id="searchOneMonth" value="ONE_MONTH" v-model="searchMonth" @click="chkSearchMonthVal($event)"><label class="btn-m btn-filter" for="searchOneMonth">1개월</label></li>
                                <li><input class="visually-hidden" type="radio" id="searchThreeMonth" value="THREE_MONTH" v-model="searchMonth" @click="chkSearchMonthVal($event)"><label class="btn-m btn-filter" for="searchThreeMonth">3개월</label></li>
                                <li><input class="visually-hidden" type="radio" id="searchAllMonth" value="ALL_DATE" v-model="searchMonth" @click="chkSearchMonthVal($event)"><label class="btn-m btn-filter" for="searchAllMonth">전체</label></li>
                            </ul>
                            <div class="body__input body__input-date">
                                <input type="date" v-model="searchStartDate" :max="`${todayDate}`" id="searchStartDate" class="form-control" @click="chkSearchSelfDateVal()">
                                ~
                                <input type="date" v-model="searchEndDate" :min="`${searchStartDate}`" :max="`${todayDate}`" id="searchEndDate" class="form-control" @click="chkSearchSelfDateVal()">
                            </div>
                        </div>
                    </div>
                    <div class="filter__item filter__item-status">
                        <p class="filter__title">사용구분</p>
                        <div class="filter__body">
                            <ul class="body__btns body__btns-status">
                                <li><input class="visually-hidden" type="radio" id="rcppayCdAll" value="ALL" v-model="searchRcppayCd" @click="chkRcppayCdVal($event)"><label class="btn-m btn-filter" for="rcppayCdAll">입금+출금</label></li>
                                <li><input class="visually-hidden" type="radio" id="rcppayCdIn" value="IN" v-model="searchRcppayCd" @click="chkRcppayCdVal($event)"><label class="btn-m btn-filter" for="rcppayCdIn">입금</label></li>
                                <li><input class="visually-hidden" type="radio" id="rcppayCdOut" value="OUT" v-model="searchRcppayCd" @click="chkRcppayCdVal($event)"><label class="btn-m btn-filter" for="rcppayCdOut">출금</label></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- 조회 버튼 -->
                <div class="btns">
                    <button type="button" id="searchHistoryBtn" class="btn-l btn-p btn-inquiry" @click="doSearch()">조회</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from '@/event/index.js';
import { mapState } from 'vuex';

export default {
    // props: {
    //     scrollY: {
    //         type: Number,
    //     }
    // },
    data(){
        return{
            searchMonth : 'ONE_MONTH',                              // 내역조회 설정 - 라디오 버튼 선택 초기값
            todayDate: new Date().toISOString().substring(0, 10),   // 현재일자
            searchStartDate: '',                                    // 검색 시작일 값
            searchEndDate: '',                                      // 검색 종료일 값
            searchRcppayCd: 'ALL',                                  // 검색 - 입출금상태
            searchValObj: {},                                       // 검색 값 object
            defaultMonth: '',
            defaultYear: '',
        }
    },

    computed: {
        ...mapState({
            visibleYescoinsFilterMobileToastPopup: state => state.modalStore.modalsObj.visibleYescoinsFilterMobileToastPopup
        })
    },

    mounted() {
        this.setSearchOneMonth();
        this.controlBodyScroll();
    },

    watch: {
        visibleYescoinsFilterMobileToastPopup(){
            this.controlBodyScroll();
        }
    },

    methods: {
        // 토스트팝업 외부영역 클릭 시 토스트팝업 숨김
        closeResultFilter() {
            this.$store.commit('modalStore/setVisibleYescoinsFilterMobileToastPopup', false);
            document.querySelector('.mobile-toast-popup').style.height = 'auto';
        },

        // 이중스크롤 제어
        controlBodyScroll(){
            if(this.visibleYescoinsFilterMobileToastPopup){
                this.$store.commit('modalStore/bodyScrollHandler');
            }else{
                this.$store.commit('modalStore/restoreBodyScroll');
            }
        },

        // 초기화 버튼 클릭
        reset(){
            this.$parent.forceRerender(); // parent: YescoinHistory.vue
        },

        // 검색날짜 세팅
        setSearchTotalMonth() {
            let fiveYearAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 5));
            this.searchStartDate = fiveYearAgo.toISOString().substring(0, 10); // 시작일
            this.searchEndDate = new Date().toISOString().substring(0, 10); // 종료일
        },

        setSearchOneMonth() {
            let oneMonthAgo = new Date(new Date().setMonth(new Date().getMonth() - 1)); // 1개월 전
            this.searchStartDate = oneMonthAgo.toISOString().substring(0, 10);
            this.searchEndDate = new Date().toISOString().substring(0, 10); // 종료일
        },

        setSearchThreeMonth() {
            let threeMonthAgo = new Date(new Date().setMonth(new Date().getMonth() - 3)); // 3개월 전
            this.searchStartDate = threeMonthAgo.toISOString().substring(0, 10);
            this.searchEndDate = new Date().toISOString().substring(0, 10); // 종료일
        },

        // 주문상태 검색값
        chkRcppayCdVal(event) {
            const element = event.currentTarget.value;
            this.searchRcppayCd = element;            
        },

        // 주문일 검색값
        chkSearchMonthVal(event) {
            const element = event.currentTarget.value;
            
            if(element === 'ONE_MONTH') {
                this.setSearchOneMonth();
            } else if(element === 'THREE_MONTH') {
                this.setSearchThreeMonth();
            } else {
                this.setSearchTotalMonth();
            }

            this.searchMonth = element;
        },

        // 주문일 직접입력 클릭 했을때
        chkSearchSelfDateVal() {
            this.searchMonth = '';
            // this.searchStartDate = new Date().toISOString().substring(0, 10);
            // this.searchEndDate = new Date().toISOString().substring(0, 10);
        },

        // 조회버튼 클릭
        doSearch() {
            // 검색값 obj 세팅
            this.setSearchValue();
            eventBus.$emit('searchValObj', this.searchValObj);

            // 창닫기
            this.closeResultFilter();

            if(window.innerWidth < 1200 ){
                
                // 모바일 버전 스크롤 위치 이동
                this.$parent.scrollToTarget('#history-wrap');

                // 상세검색 영역 닫기
                // this.closeCollaps();
            }else{
                // PC 버전 스크롤 위치 이동
                this.$parent.scrollToTarget('#visibleShowBtns');
            }
        },

        setSearchValue() {
            this.searchValObj = {
                searchRcppayCd : this.searchRcppayCd ,
                searchMonth : this.searchMonth ,
                searchStartDate : this.searchStartDate.replaceAll('-','') ,
                searchEndDate : this.searchEndDate.replaceAll('-','')
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util/inquiryfilter.scss';
</style>